import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

import { ClientReview } from 'app/shared/models/client-review.model';

@Component({
    selector: 'review',
    templateUrl: './review.component.html'
})

/**
 * Component for displaying the client reviews.
 */
export class ReviewComponent {

    @Input()
    clientReview: ClientReview[];

    constructor(private router: Router) {
    }

    daysOverdue(endDate: number) {
        let currentDate = Date.now();
        if (currentDate > endDate) {
            let one_day = 1000 * 60 * 60 * 24;
            return Math.round((currentDate - endDate) / one_day);
        }
        return 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/clients/reviews/review/review.component.ts